<style>
@import '../custom/css/area-restrita.css';
</style>

<template>
  <section class="area-restrita">
    <div v-if="ativo === 0">
      <router-view />
    </div>
    <div v-if="ativo === 99">
      <div class="ativar">
        <div class="col-12">
          <h1>Primeiro acesso</h1>
          <span class="confimation"
            >Confirme os termos e condições para liberar sua conta na
            <b>ConstrUp!</b></span
          >
          <div class="mb-3">
            <b-form-checkbox
              id="termoConfirmacao"
              name="termoConfirmacao"
              v-model="Fields.termoConfirmacao"
              required
            >
              Li e aceito os termos e condições.
              <span class="c-orange c-pointer" v-b-modal="'termos'"
                >Ver termos</span
              >
            </b-form-checkbox>
            <input type="text" v-model="Fields.id" name="id" hidden />
            <b-form-checkbox
              id="politicaPrivacidade"
              name="politicaPrivacidade"
              v-model="Fields.politicaPrivacidade"
              required
            >
              Li e aceito a política de privacidade.
              <span class="c-orange c-pointer" v-b-modal="'politicaPrivacidade'"
                >Ver termos</span
              >
            </b-form-checkbox>
          </div>
          <div class="form-group">
            <button
              type="submit"
              class="btn bg-orange c-white text-uppercase"
              @click="register()"
            >
              Ativar
            </button>
          </div>
        </div>
        <!-- Termos e Condições -->
        <TermsAndConditions />
        <!-- Política de Privacidade -->
        <PrivacyPolicy />
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import TermsAndConditions from '@/components/TermsAndConditions.vue';
import PrivacyPolicy from '@/components/PrivacyPolicy.vue';
import makeToast from '../mixins/makeToast';

export default {
  name: 'area-restrita',
  mixins: [makeToast],
  components: {
    TermsAndConditions,
    PrivacyPolicy,
  },
  data: () => ({
    ativo: 0,
    loading: false,
    Fields: {
      politicaPrivacidade: '',
      termoConfirmacao: '',
      id: '',
    },
  }),
  computed: {
    ...mapGetters([
      // Mapeamento de getters
    ]),
    ...mapState([
      // Mapeamento de states
      'token',
      'dadosUsuario',
    ]),
  },
  beforeMount() {
    if (this.dadosUsuario) {
      if (this.dadosUsuario.status === 99) {
        this.ativo = this.dadosUsuario.status;
        this.Fields.id = this.dadosUsuario.id;
      }
    }
  },
  methods: {
    register() {
      if (
        this.Fields.politicaPrivacidade === true &&
        this.Fields.termoConfirmacao === true
      ) {
        this.loading = true;
        this.$store.dispatch('startLoader');
        this.$store
          .dispatch('shopkeeper/activate', this.Fields)
          .then(() => {
            this.makeToast('Sucesso!', 'Cadastro ativado com sucesso!');
            this.ativo = 0;
            this.$store.dispatch('endLoader');
            this.loading = false;
          })
          .catch(() => {
            this.$store.dispatch('endLoader');
            this.loading = false;
            this.makeToast(
              'Oopss!',
              'Parece que houve um erro no cadastro, tente novamente mais tarde',
              'danger'
            );
          });
      } else {
        this.makeToast(
          'Oopss!',
          'Os campos Termos e Condições e Politica de privacidade são obrigatorios!',
          'danger'
        );
      }
    },
    checkIsEmpty(value) {
      if (
        value === '' ||
        value === null ||
        value === 'null' ||
        value === 'undefined'
      ) {
        return true;
      }
      return false;
    },
    goToEndereco(value) {
      this.$router.push({ name: value });
    },
  },
};
</script>

<style lang="css" scoped>
.ativar {
  max-width: 1200px;
  margin: 80px auto;
  text-align: center;
}
.ativar h1 {
  color: #ed670c;
  font-weight: 700;
}
</style>
